export const STRING      = "STRING";
export const BUSINESSKEY = "BUSINESSKEY";
export const DATE        = "DATE";
export const NUMBER      = "NUMBER";
